import { useBootstrapApi } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-api';
import { useMemo } from 'react';

const sum = (c?: { person: number; company: number }) =>
  (c?.person || 0) + (c?.company || 0);

export function useRecordCounts() {
  const { data } = useBootstrapApi();
  const count = data?.statistics?.count;

  return useMemo(
    () => ({
      listsCount: sum(count?.list),
      labelsCount: sum(count?.label),
      savedCount: sum(count?.savedSearch),
      exportsCount: sum(count?.export),
      enrichCount: sum(count?.enrichment),
    }),
    [count]
  );
}
